<template>
  <component :is="badDebtData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="badDebtData === undefined">
      <h4 class="alert-heading">獲取壞賬數據時出錯</h4>
      <div class="alert-body">
        找不到相關壞賬記錄。請查看
        <b-link class="alert-link" :to="{ name: 'bad-debt-list' }">
          壞賬名單
        </b-link>
      </div>
    </b-alert>
    <bad-debt-edit-tab-information
      v-if="badDebtData"
      :invoice-options="invoiceOptions"
      :project-options="projectOptions"
      :customer-options="customerOptions"
      :bad-debt-data="badDebtData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import badDebtStoreModule from "../badDebtStoreModule";
import badDebtEditTabInformation from "./badDebtEditTabInformation.vue";

export default {
  components: {
    badDebtEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const badDebtData = ref({ id: 0, project_id: null });
    // 新增時亦需帶齊後端會讀取的欄位，避免後端取不到 project_id
    const bad_debt = {
      id: 0,
      project_id: null,
    };

    const bad_debt_APP_STORE_MODULE_NAME = "bad-debt";

    if (!store.hasModule(bad_debt_APP_STORE_MODULE_NAME))
      store.registerModule(bad_debt_APP_STORE_MODULE_NAME, badDebtStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(bad_debt_APP_STORE_MODULE_NAME))
        store.unregisterModule(bad_debt_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "bad-debt-create") {
        badDebtData.value = bad_debt;
      } else {
        store
          .dispatch("bad-debt/fetchBadDebt", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            badDebtData.value = response.data.bad_debt;
            console.log(badDebtData.value);
          })
          .catch((error) => {
            console.log("error when fetching bad debt", error);
            if (error.response.status === 404) {
              badDebtData.value = undefined;
            }
          });
      }
    };

    const projectOptions = ref([]);
    const customerOptions = ref([]);
    const invoiceOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          projects: true,
          customers: true,
          invoices: true,
        })
        .then((response) => {
          projectOptions.value = response.data.projects;
          customerOptions.value = response.data.customers;
          invoiceOptions.value = response.data.invoices;

          refetchData();
        });
    };

    onMounted(() => {
      refetchOption();
    });

    return {
      badDebtData,
      invoiceOptions,
      projectOptions,
      customerOptions,
      refetchOption,
      refetchData,
    };
  },
};
</script>
